export const GenuineProductsSection = ({ background = "white" }) => (
  <section
    data-testid="genuine-products-section"
    className={background === "white" ? "bg-white py-20 lg:py-24" : "bg-[#F4F6F8] py-20 lg:py-24"}
  >
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="max-w-3xl">
        <h2 className="text-3xl font-extrabold text-[#0B1F33] md:text-4xl">
          Genuine Branded Products
        </h2>
        <p className="mt-6 text-base leading-relaxed text-[#263238] md:text-lg">
          AutoNeova is committed to offering genuine branded automotive replacement and maintenance
          products. We focus on accurate product identification, responsible sourcing and clear
          product information so customers can make informed purchasing decisions through our Amazon
          listings.
        </p>
      </div>
    </div>
  </section>
);

export default GenuineProductsSection;
